import { kmsClient } from 'api';
import { useMutation, useLazyQuery } from '@apollo/react-hooks';
import { UPDATE_CREATIVE_STATE } from './updateCreativeState.mutation';
import { CREATIVE_APPROVAL_MUTATION } from './creativeApproval.mutation';
import { JOBS_CREATIVES_CREATE_JOB } from './jobsCreativesCreateJob.qurey';
import { MULTI_CREATIVE_DELETE_MUTATION } from './multiDeleteCreatives.mutation';
import { DUPLICATE_OR_USE_EXISTING } from './duplicateOrUseExistingPost.mutation';
import { MULTI_DUPLICATE_CREATIVE_MUTATION } from './multiDuplicateCreatives.mutation';
import { CREATE_JOBS_CREATIVES_CREATE_JOB } from './createJobsCreativesCreateJob.mutation';
import { CreativeApproval, CreativeApprovalVariables } from './__generated__/CreativeApproval';
import { UpdateCreativeState, UpdateCreativeStateVariables } from './__generated__/UpdateCreativeState';
import { MultiDeleteCreatives, MultiDeleteCreativesVariables } from './__generated__/MultiDeleteCreatives';
import { MultiDuplicateCreatives, MultiDuplicateCreativesVariables } from './__generated__/MultiDuplicateCreatives';

import {
  DuplicateOrUseExistingPost,
  DuplicateOrUseExistingPostVariables
} from './__generated__/DuplicateOrUseExistingPost';
import {
  CreateJobsCreativesCreateJob,
  CreateJobsCreativesCreateJobVariables
} from './__generated__/CreateJobsCreativesCreateJob';
import { JobsCreativesCreateJob, JobsCreativesCreateJobVariables } from './__generated__/JobsCreativesCreateJob';

export const useCreativeApproval = () => {
  return useMutation<CreativeApproval, CreativeApprovalVariables>(CREATIVE_APPROVAL_MUTATION, {
    client: kmsClient
  });
};

export const useMultiDeleteCreatives = () => {
  return useMutation<MultiDeleteCreatives, MultiDeleteCreativesVariables>(MULTI_CREATIVE_DELETE_MUTATION, {
    client: kmsClient
  });
};

export const useMultiDuplicateCreatives = () => {
  return useMutation<MultiDuplicateCreatives, MultiDuplicateCreativesVariables>(MULTI_DUPLICATE_CREATIVE_MUTATION, {
    client: kmsClient
  });
};

export const useUpdateCreativeState = () => {
  return useMutation<UpdateCreativeState, UpdateCreativeStateVariables>(UPDATE_CREATIVE_STATE, { client: kmsClient });
};

export const useDuplicateOrUseExisting = () => {
  return useMutation<DuplicateOrUseExistingPost, DuplicateOrUseExistingPostVariables>(DUPLICATE_OR_USE_EXISTING, {
    client: kmsClient
  });
};

export const useCreateJobsCreativesCreateJob = () => {
  return useMutation<CreateJobsCreativesCreateJob, CreateJobsCreativesCreateJobVariables>(
    CREATE_JOBS_CREATIVES_CREATE_JOB,
    { client: kmsClient }
  );
};

export const useJobsCreativesCreateJob = () => {
  return useLazyQuery<JobsCreativesCreateJob, JobsCreativesCreateJobVariables>(JOBS_CREATIVES_CREATE_JOB, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
